import { useState } from 'react';
import styles from './Navbar.module.css';
import NavLogo from '../../assets/images/VFLogoNav2.png';
import LoginIcon from '../../assets/images/LoginIcon.svg';
import CustomTooltip from "../tooltip/CustomTooltip";
import { useJwt } from "react-jwt";

function Navbar() {

    // adding the states 
    const [isActive, setIsActive] = useState(false);

    //add the active class
    const toggleActiveClass = () => {
        setIsActive(!isActive);
    };

    //clean up function to remove the active class
    const removeActive = () => {
        setIsActive(false)
    }

    window.addEventListener('scroll', scrollFunction);
    function scrollFunction() {
        // if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        //     document.getElementById("logoImg").style.width = "8%";
        // }
        // else {
        //     document.getElementById("logoImg").style.width = "10%";
        // }
    }

    const token = localStorage.getItem("bb_access_token");
    const { decodedToken, isExpired } = useJwt(token);


    const handleLogout = () => {
        console.log("logout called");
        localStorage.clear();
        //navigate("/login");
        // logOut();
    };

    return (
        <div className="App">
            <header className="appHeader">

                <nav className={`${styles.navbar}`}>

                    {/* logo */}
                    <div className={`${styles.logo}`}>
                        <a href='/'>
                            <img alt="" id="logoImg" className={`${styles.logoimg}`} src={NavLogo}></img>
                        </a>
                    </div>

                    <ul className={`${styles.navMenu} ${isActive ? styles.active : ''}`}>
                        <li onClick={removeActive}>
                            <a href='https://visualisereporting.com' className={`${styles.navLink}`}>Home</a>
                        </li>
                        <li onClick={removeActive}>
                            <a href='https://visualisereporting.com/about/' className={`${styles.navLink}`}>About Us</a>
                        </li>
                        <li onClick={removeActive}>
                            <a href='https://visualisefundraising.com/services/' className={`${styles.navLink}`}>Services</a>
                        </li>
                        <li onClick={removeActive}>
                            <a href='https://visualisefundraising.com/clients/' className={`${styles.navLink}`}>Clients</a>
                        </li>
                        <li onClick={removeActive}>
                            <a href='https://visualisereporting.com/pricing/' className={`${styles.navLink}`}>Pricing</a>
                        </li>
                        <li onClick={removeActive}>
                            <a href='https://visualisereporting.com/reports/' className={`${styles.navLink}`}>Reports</a>
                        </li>
                        <li>

                            {
                                token && !isExpired ?
                                    <CustomTooltip title={"Logout"}>
                                        <a href="#" onClick={handleLogout}>
                                            <img alt="" id="loginImg" className={`${styles.loginImg}`} src={LoginIcon} />
                                        </a>
                                    </CustomTooltip>
                                    :
                                    <CustomTooltip title={"Login"}>
                                        <a href='/login'>
                                            <img alt="" id="loginImg" className={`${styles.loginImg}`} src={LoginIcon}></img>
                                        </a>
                                    </CustomTooltip>
                            }
                        </li>
                    </ul>

                    <div className={`${styles.hamburger} ${isActive ? styles.active : ''}`} onClick={toggleActiveClass}>
                        <span className={`${styles.bar}`}></span>
                        <span className={`${styles.bar}`}></span>
                        <span className={`${styles.bar}`}></span>
                    </div>
                </nav>

            </header>
        </div>
    );
}

export default Navbar;